import React from 'react';

import FieldWrapper from '../Field-wrapper';
import styles from '../Fields.module.less';
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
class SelectFieldInput extends React.Component {
    state = { focus: false };
    onFocus = () => {
        this.setState({ focus: true });
    };
    onBlur = () => {
        this.setState({ focus: false });
    };
    render() {
        const {
            choices,
            id,
            name,
            narrow = false,
            onChange,
            otherValue = 'other',
            required,
            useOther,
            inputStyle,
            value: rawValue
        } = this.props;

        const { focus } = this.state;
        if (!Array.isArray(choices)) {
            console.error(
                "SelectField passed 'choices' that wasn't array",
                name,
                choices
            );
            return <div></div>;
        }
        const choiceElements = choices.map((choice, index) => {
            if (!choice) {
                return console.error(
                    'Error: Invalid choice for select field: ',
                    choice
                );
            }
            const key = choice[0] ? choice[0] : `choice${index}`;
            return (
                <option key={key} value={choice[0]}>
                    {choice[1]}
                </option>
            );
        });

        const choiceValuesOnly = choices.map(choice => choice[0]);
        const valueIsInChoices = choiceValuesOnly.includes(rawValue);

        const otherIsInChoices = choiceValuesOnly.includes(otherValue);
        let value = rawValue;

        // If the non-null value is not included
        // in the standard choices,
        // and `useOther` is true,
        // set the value to `otherValues`
        if (!!value && useOther && !valueIsInChoices && otherIsInChoices) {
            value = otherValue;
        }

        let className = 'select-wrapper';
        if (narrow) className += '-narrow';
        if (focus) className += '-focus';

        return (
            <div className={styles[className]} tabIndex="-1">
                <select
                    id={id}
                    key={id}
                    name={name}
                    className={styles['select']}
                    style={inputStyle}
                    tabIndex="0"
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onChange={e => {
                        // In case we want to do more complex actions
                        // in dReg in future, pass props down to custom onChange function
                        return onChange(e, this.props);
                    }}
                    value={value == null ? '' : value}
                    required={required}
                >
                    {choiceElements}
                </select>
            </div>
        );
    }
}
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export default FieldWrapper(SelectFieldInput, { reduxForm: true });
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export const SelectField = FieldWrapper(SelectFieldInput);
